import React, { useState } from 'react';
import api from '../api/axios';
import { CreateClientDto, CreateClientResponseDto } from '../types';
import AddPoints from './AddPoints';
import './CreateClientModal.css';

interface CreateClientModalProps {
  onClose: () => void;
  onSuccess: () => void;
}

const CreateClientModal: React.FC<CreateClientModalProps> = ({ onClose, onSuccess }) => {
  const [step, setStep] = useState<'client' | 'points'>('client');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [createdClientId, setCreatedClientId] = useState<string | null>(null);
  
  const [formData, setFormData] = useState<CreateClientDto>({
    name: '',
    phone: '',
    cpf: '',
    email: ''
  });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post<CreateClientResponseDto>('/admin/clients', formData);
      setCreatedClientId(response.data.client.clientId);
      setStep('points');
    } catch (error: any) {
      console.error('Error creating client:', error);
      const message = error.response?.data?.message || 'Erro ao cadastrar cliente';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const handlePointsSuccess = () => {
    onSuccess();
    onClose();
  };

  const handleBack = () => {
    setStep('client');
    setError('');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal create-client-modal" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '28px' }}>
          <h2>
            {step === 'client' ? 'Cadastrar Novo Cliente' : 'Cadastrar Pontos'}
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#666',
              padding: '0',
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ×
          </button>
        </div>

        {step === 'client' ? (
          <form onSubmit={handleSubmit}>
            {error && (
              <div style={{
                padding: '12px 16px',
                background: '#FEE2E2',
                border: '1px solid #FCA5A5',
                borderRadius: '8px',
                color: '#DC2626',
                marginBottom: '20px',
                fontSize: '14px'
              }}>
                {error}
              </div>
            )}

            <div className="form-group">
              <label>Nome *</label>
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                placeholder="Nome completo do cliente"
              />
            </div>

            <div className="form-group">
              <label>Telefone *</label>
              <input
                type="tel"
                required
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                placeholder="(00) 00000-0000"
              />
            </div>

            <div className="form-group">
              <label>CPF *</label>
              <input
                type="text"
                required
                value={formData.cpf}
                onChange={(e) => setFormData({...formData, cpf: e.target.value})}
                placeholder="000.000.000-00"
              />
            </div>

            <div className="form-group">
              <label>Email (Opcional)</label>
              <input
                type="email"
                value={formData.email || ''}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                placeholder="email@exemplo.com"
              />
            </div>

            <div className="modal-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={onClose}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn-primary"
                disabled={loading}
              >
                {loading ? 'Cadastrando...' : 'Cadastrar Cliente e Continuar'}
              </button>
            </div>
          </form>
        ) : (
          <div>
            <div style={{
              padding: '16px',
              background: '#F0F9FF',
              border: '1px solid #BAE6FD',
              borderRadius: '8px',
              marginBottom: '24px',
              fontSize: '14px',
              color: '#0369A1'
            }}>
              ✓ Cliente cadastrado com sucesso! Agora você pode cadastrar pontos.
            </div>

            {createdClientId && (
              <AddPoints
                clientId={createdClientId}
                onSuccess={handlePointsSuccess}
                showCloseButton={true}
                onClose={handleBack}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateClientModal;




